export const ruleAddVendorPrices = {
  vendor: 'required',
  contact: 'required',
  workflow: 'required',
  'vendorPriceModule.effectiveFromDate': 'required|min_date:1970-01-01',
  'vendorPriceModule.effectiveToDate': 'min_date:1970-01-01'
}
